// import apiClientMiddleWare from "./apiClient";
// const allMiddles = [apiClientMiddleWare()];
const allMiddles = [];
export default allMiddles;
